import axios from "axios";
import secureLocalStorage from "react-secure-storage";
const baseURL = secureLocalStorage.getItem("baseURL");
// Get All leave Logs
export const get_all_employees_attendance_logs = async () => {
    let response = await axios.get(`${baseURL}/api/employee-attendance-activity-logs`);
    return response.data;
  };
  // New function to get attendance options
export const get_attendance_options = async (userId: string | number) => {
  try {
      const payload = {
          user_id: String(userId) // Ensure user_id is a string as per your example
      };
      const response = await axios.post(`${secureLocalStorage.getItem("baseURL")}/api/attendance-options`, payload, {
          headers: {
              'Content-Type': 'application/json',
              // Add Authorization header if required by your API
              // 'Authorization': `Bearer YOUR_TOKEN_HERE_IF_NEEDED`
          }
      });
      return response.data; // This should match the structure you provided
  } catch (error) {
      console.error("Error fetching attendance options:", error);
      if (axios.isAxiosError(error) && error.response) {
          // Return the error response from the API if available
          return error.response.data;
      }
      // Return a generic error structure if no specific API error
      return { status: false, message: "An unexpected error occurred while fetching attendance options.", data: null };
  }
};